import React from 'react';
import PropTypes from 'prop-types';
import StyledAlert from './styled';
import { buildKlarnaReauthorisationUrl } from './logic';

const renderReauthorisationMessage = (url) => (
  <div>
    <span className="title">! Action required: </span> This customer is required to setup a new Klarna
    agreement as their booking amount has changed. Send this link to the customer in an email:&nbsp;
    <a href={url} target="_blank" rel="noreferrer">
      Copy link to new agreement
    </a>
  </div>
);

const KlarnaReauthorisationAlert = ({ bookingId, segment }) => {
  const url = buildKlarnaReauthorisationUrl(bookingId, segment);
  return <StyledAlert type="info" message={renderReauthorisationMessage(url)} />;
};
KlarnaReauthorisationAlert.displayName = 'KlarnaReauthorisationAlert';

KlarnaReauthorisationAlert.propTypes = {
  bookingId: PropTypes.number.isRequired,
  segment: PropTypes.string.isRequired,
};

export default KlarnaReauthorisationAlert;
